export default "__VITE_ASSET__DuXWktX9__"